import { call, put, takeLatest } from 'typed-redux-saga'
import { errorHandler, loadersSlice } from 'Modules'
import { outOfficeManagerApi, outOfficeNS, outOfficeSlice } from 'Pages/orders_design'
import { FormNames } from 'Constants/FormNames'
import { MIN_FIND_LENGTH } from 'Constants/Global'
import { takeEveryUnique } from 'Helpers'

function* getCities(action: outOfficeNS.getCitiesRegions) {
	try {
		const { params } = action.payload
		yield* call(outOfficeManagerApi.getCitiesRegions, params)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getSlots(action: outOfficeNS.getSlots) {
	try {
		const { params } = action.payload
		yield* call(outOfficeManagerApi.getSlots, params)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getAddressSaga(action: outOfficeNS.getAddress) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const query = action.payload?.query ?? ''
		if (query?.length > MIN_FIND_LENGTH) {
			const res = yield* call(outOfficeManagerApi.getAddress, action.payload)
			yield* put(
				outOfficeSlice.actions.setAddress({
					entries: res,
				})
			)
		}
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* createAppointment(action: outOfficeNS.createAppointment) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { order_id, data, callback } = action.payload
		yield* call(outOfficeManagerApi.createAppointment, order_id, data)
		callback?.()
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error, FormNames.ORDERS.EDIT_ORDER)
	}
}

function* getPaperlessStatus(action: outOfficeNS.getPaperlessStatus) {
	try {
		const { params } = action.payload
		yield* call(outOfficeManagerApi.getPaperlessStatus, params)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* outOfficeManagerSaga() {
	yield* takeLatest(outOfficeSlice.actions.getCitiesRegions.type, getCities)
	yield* takeLatest(outOfficeSlice.actions.getSlots.type, getSlots)
	yield* takeLatest(outOfficeSlice.actions.getAddress.type, getAddressSaga)
	yield* takeEveryUnique(outOfficeSlice.actions.createAppointment.type, createAppointment)
	yield* takeLatest(outOfficeSlice.actions.getPaperlessStatus.type, getPaperlessStatus)
}
